import Vue from 'vue'
import VueI18n from 'vue-i18n'
import config from './config'
import EN from './lang/en'
import ET from './lang/et'
import FI from './lang/fi'
import LT from './lang/lt'
import LV from './lang/lv'
import RU from './lang/ru'
import SV from './lang/sv'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: config.baseLanguage,
  fallbackLocale: config.baseLanguage,
  formatFallbackMessages: true,
  messages: {
    EN,
    ET,
    FI,
    LT,
    LV,
    RU,
    SV
  }
})
